import { Box, Button, Typography } from '@mui/material'
import classNames from 'classnames/bind'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import request from '~/apis/request'
import { CloseCircleIcon } from '~/assets/icons'
import IconBell from '~/assets/icons/IconBell'
import { DEFAULT_QUANTITY } from '~/constants/home'
import STORAGE_KEYS from '~/constants/localStorage'
import { useAppContext } from '~/contexts/AppContext'
import useIsTablet from '~/hooks/useIsTablet'
import { path } from '~/routes/path'
import { ThemeContext } from '~/theme/ThemeProvider'
import { THEMES_NAME, variantStyles } from '~/theme/constants'
import { getInfoRestaurant } from '~/utils'
import styles from '../styles/PopupCallStaffReason.module.scss'
import { CallStaffItem } from './CallStaffItem'

const defaultParams = [
  {
    kind: 'call_staff',
  },
]

const cx = classNames.bind(styles)

const PopupCallStaffReasonTablet = ({ onClosePopup, open, data }) => {
  const { t } = useTranslation()
  const [selectedItems, setSelectedItems] = useState([])
  const { saveServingSessionID } = useAppContext()
  const isTablet = useIsTablet()

  const { currentThemeObject } = useContext(ThemeContext)
  const navigate = useNavigate()
  // const Transition = useMemo(() => {
  //   return React.forwardRef(function Transition(props, ref) {
  //     return <Slide direction="down" ref={ref} {...props} />
  //   })
  // }, [])

  const onGetColorText = () => {
    return currentThemeObject.value === THEMES_NAME.red_bean ||
      currentThemeObject.value === THEMES_NAME.mangosteen ||
      currentThemeObject.value === THEMES_NAME.black
      ? '#ffffff'
      : '#000000'
  }

  const getColorIcon = () => {
    return currentThemeObject.value === THEMES_NAME.red_bean ||
      currentThemeObject.value === THEMES_NAME.mangosteen ||
      currentThemeObject.value === THEMES_NAME.black
      ? '#000000'
      : '#ffffff'
  }

  const onSubmitBntClose = () => {
    setSelectedItems([])
    onClosePopup()
  }

  const onSetSelectedItem = (value) => {
    setSelectedItems(value)
  }

  //   Hàm gửi yêu cầu sau khi chọn call staff reasons
  const onSubmitCallStaffReasons = async () => {
    try {
      let params = []
      selectedItems.forEach((item) => {
        params.push({
          kind: 'call_staff',
          call_staff_reason_id: item.id,
          call_staff_option_quantity: item.call_staff_option_quantity || DEFAULT_QUANTITY,
        })
      })
      const { restaurantId, tableId } = getInfoRestaurant()
      const response = await request().post(
        `/restaurants/${restaurantId}/tables/${tableId}/requests`,
        {
          requests: params.length > 0 ? params : defaultParams,
          number_of_people: Number(localStorage.getItem(STORAGE_KEYS.NUMBER_OF_PEOPLE)),
        },
      )
      if (response.data) {
        if (response.data.serving_session_id) {
          // Đối với trường hợp separate order sẽ trả về serving_session_id
          saveServingSessionID(response.data?.serving_session_id || '')
        }
        onClosePopup()
        setSelectedItems([])
        navigate(path.callStaffTablet)
      }
    } catch (error) {
      if (!error.response) throw error
    }
  }

  const debounceCallStaff = _.debounce(() => {
    onSubmitCallStaffReasons()
  }, 200)

  // hàm show or_ask_directly
  const renderAskDirectly = () => {
    return (
      <Box className={cx('sperator_conntainer')}>
        <Box className={cx('line_style')} bgcolor={onGetColorText()} />
        <Box width="100%" color={onGetColorText()}>
          {t('descriptions.or_ask_directly')}
        </Box>
        <Box className={cx('line_style')} bgcolor={onGetColorText()} />
      </Box>
    )
  }

  // hàm hiển thị button tăng giảm quantity
  const renderListCallStaff = () => {
    return (
      <Box width={'100%'} height={348} className={cx('list_call_staff_tablet')}>
        {data.map((item) => (
          <CallStaffItem
            key={item.id}
            itemCallStaff={item}
            selectedItems={selectedItems}
            onSetSelectedItem={onSetSelectedItem}
          />
        ))}
      </Box>
    )
  }

  const renderBtnClose = () => {
    return (
      <Box className={cx('close_button')}>
        <Button onClick={onSubmitBntClose}>
          {isTablet ? (
            <CloseCircleIcon size="32" background="#000" />
          ) : (
            <CloseCircleIcon color="black" fill="black" background="white" />
          )}
        </Button>
      </Box>
    )
  }

  const renderContent = () => {
    return (
      <Box bgcolor={isTablet ? 'baseColor.color1' : ''} className={cx('dialog_wrapper')}>
        {renderBtnClose()}
        <Box className={cx('content')} bgcolor="baseColor.color1">
          <Typography className={cx('title')} color="baseColor.colorText1">
            {t('titles.customizedService')}
          </Typography>
          <Typography className={cx('sub_title')} color="baseColor.colorText1">
            {t('titles.selectOption')}
          </Typography>
          <Button
            onClick={debounceCallStaff}
            variant={variantStyles.btnAddToOrder}
            className={cx('btn_call_staff')}>
            <IconBell fill={getColorIcon()} />
            {t('titles.call_staff_reasons')}
          </Button>
          {renderAskDirectly()}
          {renderListCallStaff()}
        </Box>
      </Box>
    )
  }

  return <>{renderContent()}</>
}

export default React.memo(PopupCallStaffReasonTablet)

PopupCallStaffReasonTablet.propTypes = {
  open: PropTypes.bool,
  onClosePopup: PropTypes.func,
  onConfirm: PropTypes.func,
  data: PropTypes.array,
}
